import { Button, Flex, Text } from '@mantine/core';

import { useEvaluationOpen } from '@/module/Evaluation/model/EvaluationQuery';

import { Content } from '@/core/components';

import { useAppNotification } from '@feature/utils';

interface OpenEvaluationBoxProps {
  year: number;
}

export function OpenEvaluationBox({ year }: OpenEvaluationBoxProps) {
  const notification = useAppNotification();
  const { mutate, isPending } = useEvaluationOpen(year);

  const onClick = () => {
    mutate(undefined, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <Content type="full">
      <Flex
        justify="space-between"
        align="center"
      >
        <Text fw="500">Deschide raport evaluare anuală {year}</Text>
        <Button
          size="sm"
          onClick={onClick}
          loading={isPending}
        >
          Deschide
        </Button>
      </Flex>
    </Content>
  );
}
